// extracted by mini-css-extract-plugin
export default {"divider":"DividerStyle_divider__Xtw4V"};